<template>
    <div :class="['briefIntroduction',{briefIntroduction1: bottomActiveIndex != -1}]">
        <!-- <div class="left" v-if="bottomActiveIndex == -1">
            <h2>{{ detailedData.title }}</h2>
            <p>{{ detailedData.description }}</p>
            <div class="navigationButton gzw_daj"><img src="@/assets/svg/map/navigation.svg"> 导航</div>
        </div>
        <div class="bottom" v-if="bottomActiveIndex != -1">
            <div class="bottomLeft">
                <img :src="bottomLeftImg">
            </div>
            <div class="bottomRight">
                <h2>{{ detailedData.title }}</h2>
                <p>{{ detailedData.addr }}</p>
                <div class="bottomBottom">
                    <div class="navigationButton gzw_daj" @click="navigationButtonClick"><img src="@/assets/svg/map/navigation.svg"> {{ staticStateData.text.briefIntroduction.navigationButton }}</div>
                    <div class="seeDetails" @click="seeDetailsClick">查看详情<span></span></div>
                </div>
            </div>
        </div> -->
        <!-- 服务详情 -->
        <div class="leftBox" v-if="leftActiveIndex != -1">
            <div class="left">
                <h2>{{ detailedData.title }}</h2>
                <p>{{ detailedData.addr }}</p>
            </div>
            <div class="right" @click="rightClick">
                <img src="@/assets/svg/map/navigation.svg">
                <span>导航</span>
            </div>
        </div>
        <!-- 景区乡村玩转详情 -->
        <div class="bottomBox" v-if="bottomActiveIndex != -1 || (leftActiveIndex == -1 && bottomActiveIndex == -1)">
            <div class="left">
                <img :src="bottomLeftImg">
                <div class="textBox">
                    <h2>{{ detailedData.title }}</h2>
                    <p v-show="bottomActiveIndex != 2">{{ detailedData.addr }}</p>
                    <p v-show="bottomActiveIndex == 2" class="routerAddr">{{ routerAddr }}</p>
                    <div class="seeDetails" @click="seeDetails">查看详情<img src="@/assets/img/map/seeDetails.png"></div>
                </div>
            </div>
            <div class="right" v-show="bottomActiveIndex != 2" @click="rightClick">
                <img src="@/assets/svg/map/navigation.svg">
                <span>导航</span>
            </div>
        </div>
    </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
let mapData = createNamespacedHelpers("mapData");
let publicData = createNamespacedHelpers("publicData");
export default {
    data() { 
        return {

        }
    },
    methods: {
        rightClick(){
            this.$emit("NavigationFun",this.detailedData);
        },
        navigationButtonClick(){
            this.$emit("NavigationModeShow");
        },
        seeDetails(){
            if(this.bottomActiveIndex != 3){
                let index = this.bottomActiveIndex < 2?this.bottomActiveIndex:4;
                let arr = this.allData[2].dataArr;
                let secondLevelIndex;
                for(let i = 0; i < arr.length; i++){
                    for(let j = 0; j < arr[i].list.length; j++){
                        if(arr[i].list[j].title == this.detailedData.title){
                            this.setIndex({firstLevelIndex: 2,secondLevelIndex:arr[i].secondLevelIndex,levelThreeIndex: j});
                            secondLevelIndex = arr[i].secondLevelIndex;
                            break;
                        }
                    }
                }
                secondLevelIndex < 4?this.$router.push("/panorama"):this.$router.push("/routerDetails");
            }else{
                let arr = this.allData[3].dataArr[this.detailedData.gpsIndex].list;
                for(let i = 0; i < arr.length; i++){
                    if(arr[i].title == this.detailedData.title){
                        this.setIndex({firstLevelIndex: 3,secondLevelIndex: this.detailedData.gpsIndex,levelThreeIndex: i});
                        break;
                    }
                }
                this.setMapJumpListFlag(true);
                this.$router.push("/secondLevelPage");
            }
        },
        ...publicData.mapMutations(["setMapJumpListFlag","setIndex"])
    },
    computed: {
        bottomLeftImg(){
            if(this.detailedData.images){
                let arr = this.detailedData.images.replace(/\n/g,"").split("<br />");
                for(let i = 0; i < arr.length; i++){
                    if(arr[i].indexOf("gps") != -1 || arr[i].indexOf("GPS") != -1){
                        return this.getImgSrc(arr[i],[],false);
                    }
                }
            }
            return "";
        },
        routerAddr(){
            if(this.detailedData.content_2){
                let arr = this.detailedData.content_2.replace(/\n/g,"").split("<br />");
                let str = "";
                arr.forEach(item => {
                    if(item.length > 10){
                        str += "——" + item.split("#")[0];
                    }else{

                    }
                });
                return str.replace(/——/,"")
            }
            return "";
        },
        ...mapData.mapState(["detailedData","bottomActiveIndex","rightListState","leftActiveIndex"]),
        ...publicData.mapState(["allData","staticStateData"]),
    },
}
</script>

<style lang="scss" scoped>
.briefIntroduction{
    width: 6.9rem;
    // height: 2rem;
    height: 2.3rem;
    &.briefIntroduction1{
        height: 2.3rem;
    }
    background: #fff;
    border-radius: .1rem;
    box-shadow:0rem .08rem .08rem 0rem rgba(50,50,50,0.2);
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 2.04rem;
    .bottomBox{
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: .26rem .48rem .24rem .18rem;
        .left{
            display: flex;
            align-items: center;
            img{
                width: 1.8rem;
                height: 1.8rem;
            }
            .textBox{
                margin-left: .29rem;
                h2{
                   font-size: .36rem;
                    color: #333;
                    font-weight: bold; 
                }
                p{
                    width: 2.85rem;
                    color: #999;
                    font-size: .22rem;
                    line-height: .32rem;
                    margin-top: .14rem;
                    &.routerAddr{
                        width: 100%;
                        text-overflow: -o-ellipsis-lastline;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        line-clamp: 2;
                        -webkit-box-orient: vertical;
                    }
                }
                .seeDetails{
                    display: flex;
                    align-items: center;
                    color: #388DFF;
                    font-size: .26rem;
                    margin-top: .28rem;
                    img{
                        width: .52rem;
                        height: .1rem;
                        margin-left: .06rem;
                    }
                }
            }
        }
        .right{
            width: auto;
            height: 1.2rem;
            border-left: .01rem solid #b1b1b1;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding-left: .4rem;
            img{
                width: .44rem;
            }
            span{
                color: #4EC0AC;
                font-size: .26rem;
                margin-top: .08rem;
            }
        }
    }
    .leftBox{
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: .4rem .48rem .4rem .36rem;
        .left{
            h2{
                font-size: .36rem;
                color: #333;
                font-weight: bold;
            }
            p{
                width: 4.4rem;
                color: #999;
                font-size: .22rem;
                line-height: .32rem;
                margin-top: .24rem;
            }
        }
        .right{
            width: auto;
            height: 1.2rem;
            border-left: .01rem solid #b1b1b1;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding-left: .4rem;
            img{
                width: .44rem;
            }
            span{
                color: #4EC0AC;
                font-size: .26rem;
                margin-top: .08rem;
            }
        }
    }











    /* background: #fff;
    border-radius: .1rem;
    box-shadow:0rem .08rem .08rem 0rem rgba(50,50,50,0.2);
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 0.46rem;
    .left{
        padding: .5rem .3rem 1rem;
        h2{
            font-size: .4rem;
            color: #333;
            font-weight: bold;
        }
        p{
            color: #999;
            font-size: .3rem;
            margin-top: .32rem;
        }
        .navigationButton{
            width: 1.36rem;
            height: .58rem;
            border: .02rem solid #3289FF;
            border-radius: .04rem;
            font-size: .28rem;
            color: #3289FF;
            position: absolute;
            right: .36rem;
            bottom: .3rem;
            img{
                width: .3rem;
            }
        }
        .seeDetails{
            font-size: .26rem;
            color: #3289FF;
        }
    }
    .bottom{
        padding: .4rem .26rem;
        display: flex;
        align-items: center;
        .bottomLeft{
            width: 1.8rem;
            height: 1.8rem;
        }
        .bottomRight{
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
            padding: .4rem .26rem .4rem 2.2rem;
        }
        h2{
            font-size: .34rem;
            color: #333;
            font-weight: bold;
            white-space: nowrap;
            letter-spacing: -0.02rem;
        }
        p{
            color: #999;
            font-size: .3rem;
            margin-top: .24rem;
            white-space: nowrap;
        }
        .bottomBottom{
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: .42rem;
        }
        .navigationButton{
            width: 1.08rem;
            height: .46rem;
            border: .02rem solid #3289FF;
            border-radius: .04rem;
            font-size: .25rem;
            color: #3289FF;
            img{
                width: .24rem;
            }
        }
        .seeDetails{
            font-size: .26rem;
            color: #3289FF;
            display: flex;
            align-items: center;
            span{
                display: block;
                height: .16rem;
                width: .16rem;
                border-width: 0 .04rem .04rem 0;
                border-color: #3289FF;
                border-style: solid;
                transform: matrix(0.71, 0.71, -.71, 0.71, 0, 0) rotate(-90deg);
                margin-left: .1rem;
            }
        }
    } */
    
}
</style>